// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/link.js';

import { paths } from '../generated/link';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('link', Original, paths);
